export function parseMnemonicCanvasData(raw: unknown): Record<string, unknown> | null {
    if (raw == null) {
        return null;
    }

    let parsed: unknown = raw;

    for (let depth = 0; depth < 2; depth += 1) {
        if (typeof parsed !== 'string') {
            break;
        }

        try {
            parsed = JSON.parse(parsed);
        } catch {
            return null;
        }
    }

    if (!parsed || typeof parsed !== 'object') {
        return null;
    }

    const record = parsed as Record<string, unknown>;

    if (!Array.isArray(record.objects) && record.data != null) {
        return parseMnemonicCanvasData(record.data);
    }

    return record;
}

export function extractMnemonicCanvasMeta(json: Record<string, unknown>): {
    canvasZoom?: number;
    viewPort?: number[];
    width?: number;
    height?: number;
} {
    return {
        canvasZoom: typeof json.canvasZoom === 'number' ? json.canvasZoom : undefined,
        viewPort: Array.isArray(json.viewPort) ? (json.viewPort as number[]) : undefined,
        width: typeof json.width === 'number' && json.width > 0 ? json.width : undefined,
        height: typeof json.height === 'number' && json.height > 0 ? json.height : undefined,
    };
}

export function stripMnemonicCanvasMeta(json: Record<string, unknown>): Record<string, unknown> {
    const result = { ...json };

    delete result.canvasZoom;
    delete result.viewPort;
    delete result.width;
    delete result.height;

    return result;
}
